module.exports = ".oculto{\n\tdisplay: none;\n\tvisibility: hidden;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/relatorios/relatorios.component.css
// module id = ./src/app/relatorios/relatorios.component.css
// module chunks = main